module.exports = __webpack_public_path__ + "static/img/hot.b15db176.svg";